import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";

import ModalLoader from "./ModalLoader";

const AskQuestionModal = lazy(() => import("./AskQuestionModal"));
const CustomizeActivityModal = lazy(() => import("./CustomizeActivityModal"));
const MemberDetails = lazy(() => import("./MemberDetails"));
const UserDetails = lazy(() => import("./UserDetails"));
const Completed = lazy(() => import("./Completed"));
// const ModalLoader = lazy(() => import("./ModalLoader"));

const VerifyOTP = lazy(() => import("./UserDetails/VerifyOtp"));
const AskDetails = lazy(() => import("./UserDetails/AskDetails"));

const ModalConductor = props => {
  const modalContainer = document.getElementById("lms-modal-root");
  switch (props.currentModal) {
    case "ASK_QUESTION":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <AskQuestionModal {...props} />
        </Suspense>,
        modalContainer
      );

    case "CUSTOMIZE_ACTIVITY":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <CustomizeActivityModal {...props} />
        </Suspense>,
        modalContainer
      );
    case "MEMBER_DETAILS":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <MemberDetails {...props} />
        </Suspense>,
        modalContainer
      );

    case "USER_DETAILS":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <UserDetails {...props} />
        </Suspense>,
        modalContainer
      );
    case "THANK_YOU":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <Completed {...props} />
        </Suspense>,
        modalContainer
      );
    case "VERIFY_OTP":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <VerifyOTP {...props} />
        </Suspense>,
        modalContainer
      );
    case "ASK_USER_DETAILS":
      return ReactDOM.createPortal(
        <Suspense fallback={<ModalLoader />}>
          <AskDetails {...props} />
        </Suspense>,
        modalContainer
      );
    default:
      return null;
  }
};

export default ModalConductor;
